'use client';

import { matchesHostname } from '@dte/otw-utils-url/src/getHostname';
import type { ITelemetryItem } from '@microsoft/applicationinsights-web';

// Things we don't need to worry about logging successes for
const hostnames = [
	// Don't fill up logs with requests for map tiles
	'arcgis.com',
	// We don't need to know that App Insights was able to talk to itself
	'monitor.azure.com',
	// Don't need to monitor successful logging for fullstory
	'fullstory.com',
	// Skip successful login requests
	'login.microsoftonline.com',
	// Pageview requests will cover these
	'outageadmin.sites.dteenergy.com',
];

// TODO: may need to update for App Insights 3.4 SDK
interface RemoteDependencyData {
	target?: string;
	success?: boolean;
}

function getDependencyData(envelope: ITelemetryItem | undefined): RemoteDependencyData | undefined {
	const baseType = envelope?.baseType;
	if (baseType !== 'RemoteDependencyData') {
		return undefined;
	}

	return envelope.baseData as RemoteDependencyData;
}

function shouldFilterDependencyUrl(url: string | undefined): boolean {
	for (const hostname of hostnames) {
		if (matchesHostname(url, hostname)) {
			return true;
		}
	}

	return false;
}

export function filterDependencyTracking(envelope: ITelemetryItem | undefined): boolean {
	// Skip some dependencies
	const dependencyData = getDependencyData(envelope);

	// Don't need to filter something that isn't a dependency
	if (!dependencyData) {
		return true;
	}

	// Don't skip calls that have failed
	if (!dependencyData.success) {
		return true;
	}

	// Filter based on the target URL
	if (shouldFilterDependencyUrl(dependencyData.target)) {
		return false;
	}

	// Allow all other telemetry items
	return true;
}
